import { render, staticRenderFns } from "./QuickBackup.vue?vue&type=template&id=723416b0&scoped=true"
import script from "./QuickBackup.vue?vue&type=script&lang=js"
export * from "./QuickBackup.vue?vue&type=script&lang=js"
import style0 from "./QuickBackup.vue?vue&type=style&index=0&id=723416b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723416b0",
  null
  
)

export default component.exports